import { useState } from 'react';
import { clsx } from 'clsx';
import type { TaskStep } from '@tailorcast/shared-types';

interface StepDetailProps {
  step: TaskStep;
  taskId: string;
}

const statusIcons: Record<string, string> = {
  pending: 'text-gray-400',
  running: 'text-blue-500',
  completed: 'text-green-500',
  failed: 'text-red-500',
  skipped: 'text-gray-400',
};

const statusSymbols: Record<string, string> = {
  pending: '\u25CB',
  running: '\u25CF',
  completed: '\u2713',
  failed: '\u2717',
  skipped: '\u2014',
};

export function StepDetail({ step }: StepDetailProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="border border-gray-100 rounded-lg p-3">
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
        <span className={clsx('text-sm font-bold', statusIcons[step.status])}>
          {statusSymbols[step.status]}
        </span>
        <span className="text-xs text-gray-400 w-6">#{step.stepNumber}</span>
        <span className="text-sm text-gray-700 flex-1 truncate">{step.description}</span>
        {step.requiresApproval && (
          <span className="text-xs px-1.5 py-0.5 bg-yellow-50 text-yellow-700 rounded">
            {step.approvalStatus ?? 'approval'}
          </span>
        )}
      </div>

      {expanded && (
        <div className="mt-3 pl-9 text-xs text-gray-500 space-y-1">
          <div>
            Tool: <span className="font-mono">{step.toolName}</span>
          </div>
          {step.error && <div className="text-red-600">Error: {step.error}</div>}
          {step.startedAt && <div>Started: {new Date(step.startedAt).toLocaleString()}</div>}
          {step.completedAt && <div>Completed: {new Date(step.completedAt).toLocaleString()}</div>}
        </div>
      )}
    </div>
  );
}
